var App = App || {};

App.Header = (function ($) {
    'use strict';

    function MobileMenu() {

        const offcanvas = $("#header-mobile-menu");
        const levels = offcanvas.find(".mobile-menu-levels");
        const buttons = offcanvas.find("button[data-mobilemenu]");

        $(".btn-login-mobile").on("click", function () {
            $(this).parents(".mobile-menu-header").find(".btn-close").click();
        });

        offcanvas.on("hidden.bs.offcanvas", function () {
            // reset
        });

        buttons.on("click", function () {

            const currentLevel = parseInt(levels.attr("data-level"));
            const currentItem = levels.find(`.mobile-menu-level[data-level="${currentLevel}"]`).find(".mobile-menu-level-item.active");

            const nextItem = $(`#${$(this).attr("aria-controls")}`);
            const nextLevel = parseInt(nextItem.parents(".mobile-menu-level").attr("data-level"));

            currentItem.removeClass("active");
            nextItem.addClass("active");

            levels.attr("data-level", nextLevel);

        });
    }

    return {
        MobileMenu: MobileMenu
    };

})(jQuery);
